<template>
  <div>
    <div>
      <div v-show="!selectedPeriod.period">
        <Alert type="warning">
          <span> É necessário adicionar o Período de Locação!</span>
        </Alert>
      </div>
      <div v-show="selectedPeriod.period">
        <SelectOptionPeriodRent
          :rentId="rent.id"
          v-model="selectedPeriod"
        />
        <Button
          _key="btnItemsRentCreateUpdate"
          title="Produto"
          classIcon="fas fa-plus-circle"
          type="primary"
          size="small"
          :disabled="selectedPeriod.showAll"
          :clicked="create"
        />
        <div
          v-if="!operational"
          class="side-by-side"
        >
          <ImportProductByRent
            v-if="selectedPeriod.period"
            module="rent"
            :operational="operational"
            :targetId="rent.id"
            :periodRentId="selectedPeriod.period.id"
            :selectedPeriod="selectedPeriod"
          />
        </div>
      </div>
    </div>
    <Modal
      title="Produtos"
      :width="1100"
      :height="750"
      v-show="showModal('addProduct')"
      :onHideModal="hideSearchProduct"
    >
      <SearchProduct
        v-if="showSearchProduct"
        :types="types"
        :status="1"
        :showPrice="!operational"
        :showAvailability="true"
        :operational="operational"
        :periodRent="selectedPeriod.period.fullPeriod"
        :addProduct="addProduct"
      >
        <div slot="start">
          <Alert
            v-if="!withoutGroupStructure && kitOrAcessory === 'kit'"
            type="info"
          >
            <span>
              O produto está sendo adicionado no
              <template v-if="kitName">
                <b>{{ kitName }}</b>
              </template>.
            </span>
          </Alert>
          <Alert
            v-else-if="!withoutGroupStructure && kitOrAcessory === 'accessory'"
            type="info"
          >
            <span>O produto está sendo adicionado como acessório.</span>
          </Alert>
          <GroupSubgroupSelector
            v-else-if="!withoutGroupStructure"
            :selectedPeriod="selectedPeriod"
            :operational="operational"
            v-model="groupSelected"
          />
        </div>
      </SearchProduct>
    </Modal>

    <Modal
      title="Como deseja inserir o Kit?"
      :width="520"
      :height="260"
      v-show="showKitTypeModal"
      :onHideModal="hideKitTypeModal"
    >
      <div class="kit-modal-container">
        <div class="kit-options-group">
          <button
            class="kit-option-button"
            :disabled="loadingKitType !== null"
            @click="selectKitType('unificado')"
          >
            <vue-loading
              v-if="loadingKitType === 'unificado'"
              type="bubbles"
              color="#D98621"
              :size="{ width: '36px', height: '36px' }"
            />
            <i
              v-else
              class="fas fa-cube kit-icon kit-icon--unificado"
            ></i>
            <span class="kit-label title">Unificado</span>
            <small class="kit-description">Um único item</small>
          </button>
          <button
            class="kit-option-button"
            :disabled="loadingKitType !== null"
            @click="selectKitType('desmembrado')"
          >
            <vue-loading
              v-if="loadingKitType === 'desmembrado'"
              type="bubbles"
              color="#D98621"
              :size="{ width: '36px', height: '36px' }"
            />
            <i
              v-else
              class="fas fa-cubes kit-icon kit-icon--desmembrado"
            ></i>
            <span class="kit-label title">Desmembrado</span>
            <small class="kit-description">Itens separados</small>
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import ImportProductByRent from "../shared/import-product-rent/ImportProductByRent.vue";
import SelectOptionPeriodRent from "../period-rental/SelectOptionPeriodRent.vue";
import SearchProduct from "../../stock/search-product/SearchProduct.vue";
import GroupSubgroupSelector from "./GroupSubgroupSelector.vue";

import ItemsRent from "./ItemsRent.js";

import { mapMutations, mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "ItemsRentCreate",
  components: {
    Modal,
    Button,
    Select,
    Alert,
    SearchProduct,
    SelectOptionPeriodRent,
    GroupSubgroupSelector,
    ImportProductByRent,
  },
  props: {
    rent: Object,
    kitId: String,
    kitName: { type: String, default: "" },
    itemsRentId: String,
    kitOrAcessory: String,
    operational: { type: Boolean, default: false },
    changed: Function,
  },
  data() {
    return {
      itemsRent: new ItemsRent(),
      selectedPeriod: {},
      urlCreate: `/api/v1/${
        this.operational ? "operational" : "rental"
      }/items-rent/create`,
      showSearchProduct: false,
      groupSelected: {},
      showKitTypeModal: false,
      pendingProduct: null,
      loadingKitType: null,
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("rent", ["withoutGroupStructure"]),
    selectedKitId() {
      return this.kitOrAcessory === "kit" ? this.kitId : null;
    },
    types() {
      return this.kitOrAcessory !== "accessory" ? "1,2,3,4,5" : "0,2,0,0,0";
    },
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    ...mapActions("generic", ["postApi"]),
    create() {
      this.openModal("addProduct");
      this.removeLoading(["btnItemsRentCreateUpdate"]);
      this.showSearchProduct = true;
    },
    addProduct(product) {
      if (product.type === 4 && !this.operational) {
        this.pendingProduct = product;
        this.showKitTypeModal = true;
        this.removeLoading([product.id]);
        return;
      }
      this.updateClassItemsRent(product);
      let params = {
        url: this.urlCreate,
        obj: {
          ...this.itemsRent,
          withoutGroupStructure: this.withoutGroupStructure,
        },
        notNotifyToast: false,
      };
      this.postApi(params).then((response) => {
        this.addEvent({
          name: "addedProduct",
          data: {
            showAll: false,
            period: { id: this.selectedPeriod.period.id },
          },
        });

        this.addEvent({ name: "updateTotalizationRent" });
        this.removeLoading([product.id]);
      });
    },
    hideSearchProduct() {
      this.showSearchProduct = false;
      this.addEvent({ name: "hideModalSearchProduct" });
    },
    hideKitTypeModal() {
      this.showKitTypeModal = false;
      this.pendingProduct = null;
      this.loadingKitType = null;
    },
    selectKitType(kitType) {
      if (this.pendingProduct) {
        this.loadingKitType = kitType;
        this.pendingProduct.kitType = kitType;
        this.updateClassItemsRent(this.pendingProduct);
        this.itemsRent.kitType = kitType;
        let params = {
          url: this.urlCreate,
          obj: {
            ...this.itemsRent,
            withoutGroupStructure: this.withoutGroupStructure,
          },
          notNotifyToast: false,
        };
        this.postApi(params).then((response) => {
          this.addEvent({
            name: "addedProduct",
            data: {
              showAll: false,
              period: { id: this.selectedPeriod.period.id },
            },
          });
          this.addEvent({ name: "updateTotalizationRent" });
          this.removeLoading([this.pendingProduct.id]);
          this.loadingKitType = null;
          this.hideKitTypeModal();
        });
      }
    },
    updateClassItemsRent(data) {
      var groupId = this.groupSelected ? this.groupSelected.groupId : "";
      this.itemsRent.groupRent = { id: groupId };
      this.itemsRent.periodRentId = this.selectedPeriod.period.id;
      this.itemsRent.productId = data.id;
      this.itemsRent.type = data.type;
      this.itemsRent.description = data.description;
      this.itemsRent.quantity = data.quantity;
      this.itemsRent.unitValue = data.value;
      this.itemsRent.unitCost = data.cost;
      this.itemsRent.replacementValue = data.replacementValue;
      this.itemsRent.percentageInsurance = data.percentageInsurance;
      this.itemsRent.calculateInsurance = data.calculateInsurance;
      this.itemsRent.statusRental = this.rent.statusRental;
      this.itemsRent.onlyStock = this.operational;
      this.itemsRent.rentId = this.rent.id;
      this.itemsRent.kitId = this.selectedKitId;
      this.itemsRent.itemsRentId =
        this.kitOrAcessory == "accessory" ? this.itemsRentId : null;
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "btnBackTimeLineAvailability") {
          this.openModal("addProduct");
          this.removeLoading(["btnBackTimeLineAvailability"]);
        }

        if (event.name == "addProductBySubgroup") {
          this.showSearchProduct = true;
          this.openModal("addProduct");
          this.groupSelected = event.data;
        }
      },
      deep: true,
    },
    selectedPeriod: {
      handler(value) {
        this.$emit("input", value);
        if (this.changed) this.changed();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.kit-modal-container {
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.kit-options-group {
  display: flex;
  gap: 25px;
  justify-content: center;
}

.kit-option-button {
  padding: 25px 35px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-width: 150px;
}

.kit-option-button:hover {
  background-color: #f6f6f8;
}

.kit-icon {
  font-size: 36px;
}

.kit-icon--unificado {
  color: #2ecc71;
}

.kit-icon--desmembrado {
  color: #3498db;
}

.kit-label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.kit-description {
  color: #999;
  font-size: 12px;
  text-align: center;
}

.div-without-group {
  margin: 0px 0px 20px 40px;
}
</style>
